module.exports = __webpack_public_path__ + "img/icon-print.f10b8375.svg";